import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const stored = localStorage.getItem("rl_token");
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export const setToken = (token) => {
  if (token) {
    localStorage.setItem("rl_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("rl_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

export const errMsg = (e, fallback = "Terjadi kesalahan. Coba lagi.") => {
  if (e?.response?.status === 413) {
    return e?.response?.data?.detail || "Ukuran file terlalu besar (Content Too Large). Maksimal 50MB.";
  }
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || e?.message || fallback;
};

export default api;
